import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCog, faPencil, faSignOut, faTrashAlt,
} from '@fortawesome/pro-light-svg-icons'

import { IconWithMenu, Link } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import useAgencySelector from '@hooks/useAgencySelector'
import useTeamMember from '@hooks/useTeamMember'
import { generateUrls } from '@hooks/useUser'

import { confirmDelete } from '@functions/entity'

interface TeamMemberActionsProps {
  teamMemberPayload: ReturnType<typeof useTeamMember>,
}

const TeamMemberActions = (props: TeamMemberActionsProps) => {
  const { teamMemberPayload } = props

  const {
    callbacks: {
      createOrEditAgencyTeamMember,
      deleteTeamMember: deleteFn,
    },
    teamMember: {
      member_role,
    },
    user,
  } = teamMemberPayload

  const isLeadAgent = member_role === 'lead_agent'

  const { selectedAgencyId } = useAgencySelector()
  const { editUserUrl } = generateUrls(user, { prefixRoute: `agencies/${selectedAgencyId}/manage` })

  const confirmDeletePayload = {
    callbacks: { deleteFn },
    strings: {
      deleteString: 'Remove',
      entityName: 'Team Member',
    },
  }

  return (
    <IconWithMenu
      boxProps={{ position: 'relative', marginLeft: 'large' }}
      icon={(
        <Link greyLink>
          <FontAwesomeIcon icon={faCog} />
        </Link>
      )}
      shouldUsePortal
    >
      {/*
       // @ts-expect-error TS2741 */}
      <IconWithMenu.Menu closeOnClick>
        {!isLeadAgent && (
          <Link
            key="edit_team_member"
            onClick={() => createOrEditAgencyTeamMember()}
          >
            <FontAwesomeIcon icon={faPencil} /> Edit Member Role
          </Link>
        )}

        <Link href={`${editUserUrl}?redirect=${generateRedirectUrl()}`}>
          <FontAwesomeIcon icon={faSignOut} /> View User
        </Link>

        {!isLeadAgent && (
          <Link
            key="remove_team_member"
            // @ts-expect-error TS2345
            onClick={() => confirmDelete(confirmDeletePayload)}
          >
            <FontAwesomeIcon icon={faTrashAlt} /> Remove Member
          </Link>
        )}
      </IconWithMenu.Menu>
    </IconWithMenu>
  )
}

export default TeamMemberActions
